module.exports = __webpack_public_path__ + "img/whats-new-11_en.318d0da.jpg";